var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27.429,
    viewBox: "0 0 24 27.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-alt",
    "data-name": "Icon awesome-calendar-alt",
    d: "M0,24.857a2.572,2.572,0,0,0,2.571,2.571H21.429A2.572,2.572,0,0,0,24,24.857V10.286H0Zm17.143-10.5a.645.645,0,0,1,.643-.643h2.143a.645.645,0,0,1,.643.643V16.5a.645.645,0,0,1-.643.643H17.786a.645.645,0,0,1-.643-.643Zm0,6.857a.645.645,0,0,1,.643-.643h2.143a.645.645,0,0,1,.643.643v2.143a.645.645,0,0,1-.643.643H17.786a.645.645,0,0,1-.643-.643Zm-6.857-6.857a.645.645,0,0,1,.643-.643h2.143a.645.645,0,0,1,.643.643V16.5a.645.645,0,0,1-.643.643H10.929a.645.645,0,0,1-.643-.643Zm0,6.857a.645.645,0,0,1,.643-.643h2.143a.645.645,0,0,1,.643.643v2.143a.645.645,0,0,1-.643.643H10.929a.645.645,0,0,1-.643-.643ZM3.429,14.357a.645.645,0,0,1,.643-.643H6.214a.645.645,0,0,1,.643.643V16.5a.645.645,0,0,1-.643.643H4.071a.645.645,0,0,1-.643-.643Zm0,6.857a.645.645,0,0,1,.643-.643H6.214a.645.645,0,0,1,.643.643v2.143A.645.645,0,0,1,6.214,24H4.071a.645.645,0,0,1-.643-.643Zm18-17.786H18.857V.857A.86.86,0,0,0,18,0H16.286a.86.86,0,0,0-.857.857V3.429H8.571V.857A.86.86,0,0,0,7.714,0H6a.86.86,0,0,0-.857.857V3.429H2.571A2.572,2.572,0,0,0,0,6V8.571H24V6A2.572,2.572,0,0,0,21.429,3.429Z",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fdc626a3dfe0a4f29c89641ab5061008.svg";
export { ForwardRef as ReactComponent };